import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

const queryKey = 'issue-statuses';

export function useIssueStatuses() {
    return useQuery({
        queryKey: [queryKey],
        queryFn: () => sdClient.getIssueStatuses({}),
    });
}

export function invalidateIssueStatuses(id: number) {
    queryClient.invalidateQueries({
        queryKey: [queryKey, id],
    });
}
